/* RESPONSIBLE TEAM: team-automation-foundations */
import AutomationFinAIAgentProcedurePreviewRoute from 'embercom/routes/apps/app/automation/fin-ai-agent/procedures/procedure/preview';

export default AutomationFinAIAgentProcedurePreviewRoute;
